// import './App.css';
import { getAuthProps, setAuthProps } from './utils/AuthenticationLibrary';
import LayoutNavigation from './navigation/LayoutNavigation';
import ComponentNavigation from '../src/navigation/ComponentNavigation';
import './css/style.scss';
// In your main entry file (e.g. index.js or App.js)
import 'primereact/resources/themes/lara-light-blue/theme.css';  // or another theme
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import AdminServices from './services/axiosServices/apiServices/adminServices';
import { useEffect, useState } from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';



function App() {
  const adminServices = new AdminServices();
  const authDetails = getAuthProps();
  const [loading, setLoading] = useState(true);
  // let token = localStorage.getItem('APToken') || sessionStorage.getItem('APToken');

  // if (window.location.pathname === "/") {
  //   window.location.href = "/Login";
  // }
  // else {
  //   if (window.location.pathname.toLocaleLowerCase() !== "/login" && window.location.pathname.toLocaleLowerCase() !== "/set-password" && window.location.pathname.toLocaleLowerCase() !== "/forgot-password") {
  //     if (token && authDetails === undefined) {
  //       adminServices.verifyAuth(token).then((response) => {
  //         if (response && response.success === 1) {
  //           let authDetails = response.userData.userDetails;
  //           authDetails.token = response.token;
  //           setAuthProps(authDetails);

  //         }
  //       });
  //     } else if (authDetails) {
  //       ComponentNavigation.forEach(element => {
  //         element.authDetails = authDetails;
  //       });
  //     }
  //     else {

  //       switch (window.location.pathname.toLocaleLowerCase()) {
  //         case "/set-password":
  //           window.location.href = "/set-password";
  //           break;
  //         case "/forgot-password":
  //           window.location.href = "/forgot-password";
  //           break;
  //         case "/login":
  //           window.location.href = "/Login";
  //           break;
  //         default:
  //           window.location.href = "/Login";

  //       }

  //     }
  //   }
  // }

  useEffect(() => {
    const token = localStorage.getItem("APToken");
    const currentPath = window.location.pathname.toLowerCase();
    const publicRoutes = ["/login", "/set-password", "/forgot-password", "/approve-form"];

    if (currentPath === "/") {
      window.location.href = "/Login";
      return;
    }

    if (token && !authDetails) {
      adminServices.verifyAuth(token).then((response) => {
        if (response && response.success === 1) {
          let authDetails = response.userData.userDetails;
          authDetails.token = response.token;
          setAuthProps(authDetails);
          window.location.href = "/dashboard";
        } else {
          localStorage.removeItem("APToken");
          if (!publicRoutes.includes(currentPath)) {
            window.location.href = "/Login";
          }
        }
        setLoading(false);
      });
    } else if (authDetails) {
      ComponentNavigation.forEach(element => {
        element.authDetails = authDetails;
      });
      setLoading(false);
    } else if (!token && !publicRoutes.includes(currentPath)) {
      window.location.href = "/Login";
      setLoading(false);
    } else {
      setLoading(false);
    }
  }, []);

  if (loading) {
    return <div className="flex justify-center items-center w-full py-4">
      <ProgressSpinner style={{ width: '40px', height: '40px' }} strokeWidth="4" />
    </div>
  }

  return (
    <>
      <LayoutNavigation componentRoutes={ComponentNavigation} authDetails={authDetails} />
    </>

  );
}

export default App;
